module.exports = __webpack_public_path__ + "9e1e143aa78ca601f2959e65cb225d5b.svg";